import React from "react";
import NumberRenderer from "components/common/ag-grid/NumberRenderer";
import { Link } from 'react-router-dom';
import { ProgressBar } from "components/common";
import ProjectStatusRenderer from 'components/app/crm/project/component/ProjectStatusRenderer';

export const columnDefs = [
    { 
      headerName: 'PCV number',
      field: 'pcv_number',
      minWidth: 110,
      cellRenderer: (params) => {
        const data = params.data
        return (
          <Link to={`/crm/projects/${data.id}`}>{params.value}</Link>
        )
      }
    },
    { 
      headerName: 'Project name',
      field: 'name',
      minWidth: 200,
      cellRenderer: (params) => {
        const data = params.data
        return (
          <Link to={`/crm/projects/${data.id}`}>{params.value}</Link>
        )
      }
    },
    { 
      headerName: 'Quote number',
      field: 'q_number',
      minWidth: 120
    },
    { 
      headerName: 'P/J number',
      field: 'j_number',
      minWidth: 120,
      cellRenderer: (params) => {
        return <span className="tw-text-amber-600">{params.value}</span>
      }
    },
    {
      headerName: 'Sales Pipeline',
      field: 'sales_pipeline.name',
      minWidth: 170,
      cellRenderer: (params) => (
        <ProjectStatusRenderer value={params.data?.sales_pipeline?.name ?? '—'} data={params.data} />
      )
    },
    { 
      headerName: 'Buyer name',
      field: 'customer.name',
      minWidth: 200,
      cellRenderer: (params) => {
        const {customer} = params.data
        return (
          <Link to={`/crm/projects/${customer.id}`}>{customer.name}</Link>
        )
      }
    },
    { 
      headerName: 'Buyer code',
      field: 'customer.type_of_customer',
      minWidth: 120
    },
    { 
      headerName: 'Enduser',
      field: 'enduser.name',
      minWidth: 200,
      cellRenderer: (params) => {
        const {customer} = params.data
        return (
          <Link to={`/crm/customers/${customer.id}`}>{customer.name}</Link>
        )
      }
    },
    { 
      headerName: 'Contractor',
      field: 'contractor.name',
      minWidth: 200,
      cellRenderer: (params) => {
        const {contractor} = params.data
        return (
          contractor ? (<Link to={`/crm/customers/${contractor.id}`}>{contractor.name}</Link>) : null
        )
      }
    },
    { 
      headerName: 'Consultant',
      field: 'consultant.name',
      minWidth: 200,
      cellRenderer: (params) => {
        const {consultant} = params.data
        return (
          consultant ? (<Link to={`/crm/customers/${consultant.id}`}>{consultant.name}</Link>) : null
        )
      }
    },
    { 
      headerName: 'Located',
      field: 'pj_location',
      minWidth: 220
    },
    { 
      headerName: 'Weight (M.T)',
      field: 'weight',
      minWidth: 140,
      cellRenderer: NumberRenderer,
    },
    { 
      headerName: 'Area (m2)',
      field: 'area',
      minWidth: 120,
      cellRenderer: NumberRenderer
    },
    { 
      headerName: 'Sales unit',
      field: 'sales_unit.description',
      minWidth: 130
    },
    { 
      headerName: 'Competitor',
      field: 'competitor',
      minWidth: 180,
      cellRenderer: (params) => {
        const competitors = params.value
        return (
          competitors.map(competitor => competitor.name).join(", ")
        )
      }
    },
    { 
      headerName: 'Expected month signing contract',
      field: 'expected_date_of_signing_contract',
      minWidth: 140
    },
    { 
      headerName: 'Last contact',
      field: 'last_contact',
      minWidth: 120
    },
    { 
      headerName: 'T/V/E',
      field: 'tve',
      minWidth: 120
    },
    { 
      headerName: 'SEI',
      field: 'sales_incharge',
      minWidth: 120
    },
    { 
      headerName: 'Mode',
      field: 'project_mode',
      minWidth: 120
    },
    { 
      headerName: '% Success',
      field: 'percent_success',
      minWidth: 120,
      // Follows the current sales-pipeline stage probability; falls back to the
      // legacy percent_success column when the stage carries no probability.
      valueGetter: (p) => p.data?.sales_pipeline?.probability ?? p.data?.percent_success ?? 0,
      cellRenderer: (params) => {
        const value = Number(params.value) || 0;
        return (
          <ProgressBar now={value} label={`${value}%`} size="lg" />
        )
      }
    },
    { 
      headerName: 'Notes',
      field: 'notes',
      minWidth: 150
    },
    { 
      headerName: 'Created by',
      field: 'created_by',
      minWidth: 120
    },
    { 
      headerName: 'Created date',
      field: 'created_date',
      minWidth: 150
    }
  ];